module.exports = __webpack_public_path__ + "static/feature_sasha-f972a47b31510452e09627ca6bb13489.jpg";